import { render, staticRenderFns } from "./BlockActions.vue?vue&type=template&id=af76dcec&scoped=true&"
import script from "./BlockActions.vue?vue&type=script&lang=js&"
export * from "./BlockActions.vue?vue&type=script&lang=js&"
import style0 from "./BlockActions.vue?vue&type=style&index=0&id=af76dcec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af76dcec",
  null
  
)

export default component.exports